<template>
    <MainContent title="Crear evento">
        <template v-slot:header>
            <h3 class="card-title">Crear evento</h3>
        </template>
        <template v-slot:content>
            <div class="card-body" v-show="!loading">
                <div class="row">
                    <div class="col-12">
                        <FormComponent :evento="evento" v-on:terminado="crearEvento"></FormComponent>
                    </div>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
import FormComponent from '@/components/backend/eventos/FormEvento';
import MainContent from "@/components/backend/components/MainContent";

export default {    
    data() {
        return {
            evento: {
                recinto: false,
                status: 0,
                solicitar_datos: 0,
                provincia_id: null,
                n_max_asientos: 10
            },
            loading: false,
        }
    },
    computed: {
        manager() {
            return this.$store.getters.getFooter;
        }
    },
    mounted() {
        if(this.manager.tipo == 1) {
            this.evento.synopsis = `
                    <h3>Venta Oficial de entradas</h3>
                    <p class="mb-3">Disfruta el mejor partido de tu equipo comprando tus entradas en tan sólo dos minutos, una compra fácil, segura y rápida para vivir una experiencia única. No olvides en cumplir la normativa vigente en la ejecución del encuentro.</p>

                    <h3>Normativa</h3> 
                    <p>RD 203/2010 REGLAMENTO DE PREVENCIÓN DE LA VIOLENCIA, EL RACISMO, LA XENOFOBIA Y LA INTOLERANCIA EN EL DEPORTE. Recinto deportivo video vigilado para la seguridad de los asistentes y participantes en el encuentro. Causas que impiden el acceso o la permanencia en el recinto deportivo. a) Participar en altercados, riñas, peleas o desórdenes públicos. b) Introducir, portar o utilizar cualquier clase de armas o de objetos que pudieran producir los mismos efectos. c) Objetos de peso superior a 500g susceptibles de utilizar como proyectiles. d) Introducir o estar en posesión de bengalas, petardos, explosivos o, en general productos inflamables. e) Introducir o vender cualquier clase de bebidas alcohólicas, estupefacientes, psicotrópicos, estimulantes. f) Introducir, exhibir o elaborar pancartas, banderas, símbolos, u otras señas que inciten a la violencia o terrorismo. g) Realizar cánticos, expresiones, sonidos o aptitudes que inciten a la violencia o al terrorismo. h) Irrumpir en el terreno de juego. i) Haber sido sancionado con la prohibición de acceso a cualquier recinto deportivo en tanto no se haya extinguido la sanción. LA ADQUISICIÓN DE ESTA ENTRADA REPRESENTA LA ACEPTACIÓN DE LAS SIGUIENTES CONDICIONES: -La Organización no garantiza la autenticidad de esta entrada si no ha sido adquirida en los puntos de venta oficiales. No está permitida la reventa de esta entrada. Toda entrada enmendada, rota, sospechosa de falsificación o adquirida ilícitamente autorizará al organizador a privar del acceso al portador de la misma. -El personal de seguridad y control de accesos, se reserva el derecho a retirar los tapones o cubierta de todos los envases, así como todos aquellos recipientes que por su capacidad y rigidez puedan resultar peligrosos. - Conservar la entrada hasta la salida del recinto. La salida del recinto implica pérdida del derecho a entrar nuevamente, salvo en aquellos eventos que el organizador disponga lo contrario</p>
                `;
        }

        if(this.$store.getters.getFooter.lfp == 1) {
            this.evento.synopsis = `
                    <h3>Venta Oficial de entradas</h3>
                    <p class="mb-3">Disfruta el mejor partido de tu equipo comprando tus entradas en tan sólo dos minutos, una compra fácil, segura y rápida para vivir una experiencia única. No olvides en cumplir la normativa vigente en la ejecución del encuentro.</p>

                    <h3>Normativa</h3> 
                    <p>Causas que impiden el acceso o la permanencia en el recinto deportivo: a) Participar en altercados, riñas, peleas o desórdenes públicos. b) Introducir, portar o utilizar cualquier clase de armas o de objetos que pudieran producir los mismos efectos, como elementos punzantes, cortantes, o de peso superior a 500 gramos/mililitros susceptibles de utilizarse como proyectiles, tales como alimentos en recipientes rígidos, bebidas embotelladas o sus envases. c) Introducir o estar en posesión de bengalas, petardos, explosivos o, en general, productos inflamables, fumíferos o corrosivos y dispositivos pirotécnicos. d) Encontrarse bajo los efectos de bebidas alcohólicas, estupefacientes, psicotrópicos, estimulantes o sustancias análogas. e) Introducir o vender cualquier clase de bebidas alcohólicas, sustancias estupefacientes, psicotrópicas, estimulantes o análogas. f) Introducir, exhibir o elaborar pancartas, banderas, símbolos u otras señales con mensajes que inciten a la violencia o al terrorismo, o en cuya virtud una persona o grupo de ellas sea amenazada, insultada o vejada por razón de su origen racial o étnico, religión o convicciones, discapacidad, edad, sexo u orientación sexual. g) Realizar cánticos, expresiones, sonidos o actitudes que inciten a la violencia o al terrorismo, o que pretendan vejar a una persona o grupo de ellas por razón de su raza o etnia, discapacidad, religión o convicciones, sexo u orientación sexual. h) Irrumpir en el terreno de juego. i) Haber sido sancionado o suspendido con la prohibición de acceso a cualquier recinto deportivo en tanto no se haya extinguido la sanción. j) No haber abonado el precio y tributos de la entrada, no presentarla o no conservarla durante el evento k)Transmitir, distribuir, ceder, vender (o ayudar a hacerlo) cualquier descripción, anotación, imagen, video, audio, dato, estadística u otra forma de reproducción del evento, excepto para uso personal y privado. l) Aquellas otras previstas en la legislación o normativa aplicable, en particular la Ley 19/2007, de 11 de julio, el Real Decreto 203/2010, de 26 de febrero, el Reglamento para la venta de abonos y entradas de LaLiga y el Reglamento interno del recinto deportivo donde se celebre el evento. Para más información sobre el tratamiento de datos en la identificación y verificación de identidad, por favor, diríjase al Club/SAD emisor de esta entrada.</p>
                `;
        }

        this.evento.moneda = 978;
    },
    methods: {            
        crearEvento() {
            this.loading = true;

            this.evento.filters = {};

            this.evento.localidad = this.evento.location_id.nombre;
            this.evento.location_id = this.evento.location_id.id ?? 0;

            if(this.evento.place_obj) {
                this.evento.place_id = this.evento.place_obj.id;
            }            

            if(this.evento.equipo_local_id) {
                this.evento.equipo_local_id = this.evento.equipo_local_id.id;
            }

            if(this.evento.equipo_visitante_id) {
                this.evento.equipo_visitante_id = this.evento.equipo_visitante_id.id;
            }

            if(this.evento.division_id) {
                this.evento.division_id = this.evento.division_id.id;
            }

            this.$store.dispatch(this.config.getVuexAlias('back.events.crear'), this.evento).then(res => {
                this.$toast.success(res.data.message);
                this.$router.push({ name: 'back.events.index' });
            }).finally(() => this.loading = false);
        }
    },
    components: {
        FormComponent, MainContent
    }
}
</script>
